import React, { useEffect, useState } from 'react';
import Layout from '../../components/global/layout';
import Pagination from 'react-pagination-js';
import methodModel from '../../methods/methods';
import datepipeModel from '../../models/datepipemodel';
import { Tooltip } from 'antd';
import { FiEdit3, FiPlus } from 'react-icons/fi';
import { BsTrash3 } from 'react-icons/bs';
import SelectDropdown from '../../components/common/SelectDropdown';
import statusModel from '../../models/status.model';
import { FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import ApiClient from '../../methods/api/apiClient';
import Swal from 'sweetalert2';
import { HiArrowSmUp } from 'react-icons/hi';

import loader from '../../methods/loader';
import { toast } from 'react-toastify';
import { HiOutlineArrowDown } from 'react-icons/hi';

const Assessment = () => {
  let user = useSelector((state) => state.user);
  const [loaging, setLoader] = useState(true);

  const searchState = useSelector((state) => state.search);
  const [filters, setFilter] = useState({
    page: 1,
    count: 10,
    search: '',
    sortBy: 'createdAt desc',
    key: '',
    sorder: 'asc',
  });

  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const history = useNavigate();

  const isAllow = (key = '') => {
    let value = Permissions?.[key];
    if (user?.roleDetail == 'admin' || user?.roleDetail == 'admin')
      value = true;
    return value;
  };

  const GetallData = (p = {}) => {
    setLoader(true);
    let filter = { ...filters, ...p };
    ApiClient.get(`assessment/all`, filter).then((res) => {
      if (res.success) {
        setData(res?.data);
        setTotal(res?.total);
      }
      setLoader(false);
    });
  };
  useEffect(() => {
    if (user && user.loggedIn) {
      setFilter({ ...filters, search: searchState.data });
      GetallData({ search: searchState.data, page: 1 });
    }
  }, [searchState]);
  // const clear = () => {
  //   setFilter({ ...filters, search: '', status: '', page: 1 });
  //   GetallData({ search: '', status: '', page: 1 });
  // };

  const deleteItem = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to delete this`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#A12238',
      cancelButtonColor: '#1e2a36',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        // loader(true);
        ApiClient.delete('assessment', { id: id }).then((res) => {
          if (res.success) {
            setTimeout(() => {
              toast.success(res.message);
            }, 200);
            GetallData();
            // loader(false)
          }
        });
      }
    });
  };

  const renderSortIcon = (columnKey) => {
    if (filters.key !== columnKey)
      return <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
    else {
      if (filters.sorder === 'asc') {
        <HiArrowSmUp className="shrink-0 inline text-sm" />;
      } else {
        <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
      }
    }
    return filters.sorder === 'asc' ? (
      <HiArrowSmUp className="shrink-0 inline text-sm" />
    ) : (
      <HiOutlineArrowDown className="shrink-0 inline text-sm" />
    );
  };

  const edit = (id) => {
    history(`/assessment/edit/${id}`);
  };

  const view = (id) => {
    history('/assessment/view/' + id);
  };

  const UpdateStatus = (itm) => {
    let model = 'assessment';
    let status = 'active';
    if (itm.status == 'active') status = 'deactive';
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to ${status == 'active' ? 'Activate' : 'Inactive'
        } this`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#A12238',
      cancelButtonColor: '#1e2a36',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        // loader(true);
        ApiClient.put(`change/status`, {
          id: itm.id,
          status,
          model,
        }).then((res) => {
          if (res.success) {
            // setTimeout(() => {
            //   toast.success(res?.message);
            // }, 1000);
            GetallData();
          }
          // loader(false);
        });
      }
    });
  };

  const changestatus = (e) => {
    setFilter({ ...filters, status: e, page: 1 });
    GetallData({ status: e, page: 1 });
  };

  const sorting = (key) => {
    let sorder = 'asc';
    if (filters.key === key) {
      sorder = filters.sorder === 'asc' ? 'desc' : 'asc';
    }
    setFilter({ key, sorder });

    let sortBy = `${key} ${sorder}`;
    setFilter({ ...filters, sortBy, key, sorder });
    GetallData({ sortBy, key, sorder });
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    GetallData({ page: e });
  };

  const handleItemCountChange = (e) => {
    setFilter({ ...filters, page: 1, count: e?.target?.value });
    GetallData({ page: 1, count: e?.target?.value });
  };

  return (
    <>
      <Layout>
        <div className="flex justify-between items-center">
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">
              Assessment
            </h3>
            <p class="text-sm font-normal text-[#525252]">
              Here you can see all about your Assessment
            </p>
          </div>

          <div className="flex filterFlex phSpace">
            {isAllow('course_add') ? (
              <a
                className="bg-primary leading-10 mr-3 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg gap-2"
                onClick={(e) => history('/assessment/add')}
              >
                <FiPlus className="text-xl text-white" /> Add Assessment
              </a>
            ) : (
              <></>
            )}
          </div>
        </div>

        <div className="shadow-lg w-full bg-white rounded-lg mt-6">
          <div className="flex items-center justify-end p-4 gap-2">
            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="All Status"
              intialValue={filters.status}
              result={(e) => {
                changestatus(e.value);
              }}
              options={statusModel.list}
              theme="search"
            />
          </div>

          <div className="scrollbar w-full overflow-auto">
            <table class="w-full">
              <thead className="text-xs text-gray-700 capitalize bg-gray-50  border-b border-[#EAECF0]">
                <tr className="border-b border-[#EAECF0]">
                  <th
                    scope="col"
                    onClick={(e) => sorting('name')}
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap "
                  >
                    Name{' '}
                    <span className="mr-2">
                      {filters?.sortBy == 'name asc' ? (
                        <HiArrowSmUp className="shrink-0 inline text-sm" />
                      ) : (
                        <HiOutlineArrowDown className="shrink-0 inline text-sm" />
                      )}
                    </span>
                  </th>
                  <th
                    scope="col"
                    onClick={(e) => sorting('course_name')}
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                  >
                    Course{' '}
                    <span className="mr-2">{renderSortIcon('course_name')}</span>
                  </th>
                  <th
                    scope="col"
                    onClick={(e) => sorting('weightage')}
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                  >
                    Weightage{' '}
                    <span className="mr-2">{renderSortIcon('weightage')}</span>
                  </th>

                  <th
                    scope="col"
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                    onClick={(e) => sorting('minimum_score')}
                  >
                    Minimum Score <span className="mr-2"></span>
                  </th>
                  <th
                    scope="col"
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                    onClick={(e) => sorting('createdAt')}
                  >
                    Date Created{' '}
                    <span className="mr-2">{renderSortIcon('createdAt')}</span>
                  </th>

                  <th
                    scope="col"
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody id="tableBodycat">
                {!loaging && data &&
                  data?.map((itm, i) => {
                    return (
                      <tr className="">
                        <td
                          className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]"
                        >
                           <Tooltip placement="right" title="View">
                          <h4 className="user cursor-pointer"onClick={(e) => view(itm.id)}>
                            {methodModel.capitalizeFirstLetter(itm?.name)}
                          </h4>
                          </Tooltip>
                        </td>
                        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                          {methodModel.capitalizeFirstLetter(itm?.course_id?.title)}
                        </td>
                        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                          {itm?.weightage}
                        </td>



                        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                          {itm?.minimum_score}
                        </td>
                        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                          {datepipeModel.date(itm.createdAt)}
                        </td>
                        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                          <div onClick={() => UpdateStatus(itm)}>
                            <span
                              className={`${itm.status == 'deactive'
                                ? 'bg-[#A12238] text-[#fff]'
                                : 'bg-[#1c2b35] text-white'
                                } text-sm w-[100px] !px-3 h-[30px] cursor-pointer flex items-center justify-center border border-[#EBEBEB] !rounded`}
                            >
                              {itm.status == 'deactive' ? 'Inactive' : 'Active'}
                            </span>
                          </div>
                        </td>
                        <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                          <div className="flex items-center gap-1.5">
                            {isAllow('course_get') ? (
                              <>
                                <Tooltip placement="top" title="View">
                                  <a
                                    className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                    onClick={(e) => view(itm.id)}
                                  >
                                    <FaEye />
                                  </a>
                                </Tooltip>
                              </>
                            ) : (
                              <></>
                            )}
                            {isAllow('course_edit') ? (
                              <>
                                <Tooltip placement="top" title="Edit">
                                  <a
                                    className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                    title="Edit"
                                    onClick={(e) => edit(itm?.id)}
                                  >
                                    <FiEdit3 />
                                  </a>
                                </Tooltip>
                              </>
                            ) : (
                              <></>
                            )}

                            {isAllow('course_delete') ? (
                              <>
                                <Tooltip placement="top" title="Delete">
                                  <span
                                    className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                    onClick={() => deleteItem(itm.id)}
                                  >
                                    <BsTrash3 />
                                  </span>
                                </Tooltip>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          {!loaging && data?.length === 0 ? (
            <div className="py-3 text-center text-[#8b8b8b]">No Data</div>
          ) : (
            <></>
          )}
          {!loaging && total > filters?.count ? (
            <div className="paginationWrapper  mt-15">
              <span className='text-sm text-gray-600'>Show {filters.count} from {total} Assessment

              </span>
              <select
                className="border-[1px] border-[#cfd5dc] rounded-[5px] px-[5px] py-[5px] bg-white text-[12px] mr-3"
                value={filters.count} // Current value of items per page
                onChange={(e) => handleItemCountChange(e)} // Function to handle changes
              >
                {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((count) => (
                  <option key={count} value={count}>
                    {count}
                  </option>
                ))}
              </select>
              <Pagination
                currentPage={filters.page}
                totalSize={total}
                sizePerPage={filters.count}
                changeCurrentPage={pageChange}
              />

            </div>
          ) : (
            <></>
          )}
          {loaging ? (
            <div className="text-center py-4">
              <img src="/assets/img/loader.gif" className="pageLoader" />
            </div>
          ) : (
            <></>
          )}
        </div>
      </Layout>
    </>
  );
};
export default Assessment;
